<template>
  <div :class="{ error: error !== '' }">
    <Editor ref="testRef" v-model="wysiwyg" :initial-value="wysiwyg" :id="id" :apiKey="editorInfo.tinykey" :init="editorInfo.init"></Editor>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import { reactive, ref } from '@vue/reactivity';
import { watch } from '@vue/runtime-core';
import { fileUploadApi } from '@/api/integrateapi';
import _ from 'lodash';
export default {
  props: {
    id: {
      type: String,
      required: false,
      default: 'reum_editor',
    },
    idx: {
      type: Number,
      required: false,
      default: -1,
    },
    error: {
      type: String,
      required: false,
      default: '',
    },
    editData: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    Editor,
  },
  emits: ['change'],
  setup(props, context) {
    const wysiwyg = ref('');
    const testRef = ref(null);

    const editorInfo = reactive({
      tinykey: 'x390lf19rxntdmbl6uh6yx9y514xty1v20rfkwdnntbdevxq',
      contents: '',

      init: {
        selector: `#${props.id}`,
        menubar: false,
        // plugins: 'image code',
        plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
        // toolbar: 'undo redo | link image | code',
        toolbar:
          'undo redo | fontsize | table |bold italic forecolor backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | link image',
        image_title: false,
        font_size_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
        automatic_uploads: true,
        file_picker_types: 'image',
        file_picker_callback: cb => {
          let input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          input.addEventListener('change', () => {
            const file = input.files[0];
            if (file) {
              const formData = new FormData();
              formData.append('file', file);
              fileUploadApi(formData)
                .then(resp => {
                  console.log(resp);
                  const { result } = resp.data;
                  const { uploadUrl, fileName } = result;
                  cb(uploadUrl, { title: fileName });
                })
                .catch(error => {
                  if (error.response) {
                    alert('서버에서 오류가 발생하였습니다.');
                  } else if (error.request) {
                    // 요청이 이루어 졌으나 응답을 받지 못했습니다.
                    // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
                    // Node.js의 http.ClientRequest 인스턴스입니다.
                    console.log(error.request);
                    alert('서버에 응답이 없습니다.');
                  } else {
                    // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.

                    console.log('Error', error.message);
                  }
                  console.log(error.config);
                });
            }
          });

          input.click();
        },
      },
    });

    const setWysiwyg = value => {
      wysiwyg.value = value;
    };

    const editorInit = () => {
      wysiwyg.value = props.editData;
    };

    if (props.editData) {
      editorInit();
    }

    watch(
      () => wysiwyg.value,
      cur => {
        if (typeof cur === 'string') {
          const data = {
            idx: props.idx,
            contents: cur,
          };
          context.emit('change', data);
        }
      }
    );

    return {
      wysiwyg,
      editorInfo,
      editorInit,
      testRef,
      setWysiwyg,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.error {
  border: 1px solid $red;
  border-radius: 9px;
}
</style>
